export function formatToPattern(value: string, pattern: string) {
  let result = ''
  for (let im = 0, is = 0; im < pattern.length && is < value.length; im++) {
    result +=
      pattern.charAt(im) == 'X' ? value.charAt(is++) : pattern.charAt(im)
  }
  return result
}
